import { render, staticRenderFns } from "./ChartQrtPorCompetencia.vue?vue&type=template&id=0b40d564&"
import script from "./ChartQrtPorCompetencia.vue?vue&type=script&lang=js&"
export * from "./ChartQrtPorCompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports